import { render } from "./ImportNewPosts.vue?vue&type=template&id=7484debc&ts=true"
import script from "./ImportNewPosts.vue?vue&type=script&lang=ts"
export * from "./ImportNewPosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__